import api from './api';

export interface TimeSeriesData {
    date: string;
    activeUsers: string;
    screenPageViews: string;
}

export interface SummaryData {
    totalUsers: string;
    newUsers: string;
    sessions: string;
    engagementRate: string;
}

export interface CountryData {
    country: string;
    users: string;
}

export interface TrafficSourceData {
    channel: string;
    sessions: string;
}

export interface ComprehensiveAnalyticsData {
    timeSeries: TimeSeriesData[];
    summary: SummaryData;
    byCountry: CountryData[];
    byTrafficSource: TrafficSourceData[];
}

export const getAnalytics = async (): Promise<ComprehensiveAnalyticsData> => {
  const response = await api.get('/analytics/stats');
  return response.data;
};